import KformComponent from '../kform-component';
import Card from '~/scripts/services/model/card';

export default class JsoneditorComponent extends KformComponent {
	/**
	 * @param {import('@knitiv/api-client-javascript').ComponentJsonEditor | undefined} settings
	 */
	constructor(settings = undefined) {
		super(settings);
		this.autofocus = settings?.autofocus ?? false;
		this.defaultValue = settings?.defaultValue ?? '';
		this.event = {
			onChange: undefined,
			...settings?.event,
		};
		this.input = false;
		this.options = {
			colorPicker:     true,
			enableSort:      true,
			enableTransform: true,
			escapeUnicode:   false,
			history:         true,
			indentation:     2,
			mainMenuBar:     true,
			mode:            'tree',
			modes:           [],
			name:            undefined,
			navigationBar:   true,
			search:          true,
			statusBar:       true,
			templates:       [],
			timestampTag:    true,
			...settings?.options,
		};
		this.persistent = settings?.persistent ?? true;
		this.preferText = settings?.preferText ?? true;
		this.protected = settings?.protected ?? false;
		this.kdata = {
			submit: true,
			...settings?.kdata,
		};
		this.validate = {
			schema: settings?.validate?.schema ?? {},
			card: new Card(settings?.validate?.card ?? '0-1'),
		};
	}

	/**
	 * @returns {Set<string>}
	 */
	getSubmissionKeys() {
		return new Set([]);
	}
}